var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 2H19.25C21.3211 2 23 3.67893 23 5.75V14.25C23 16.3211 21.3211 18 19.25 18H11.2742L6.73316 21.8239C6.28758 22.1992 5.5 21.8824 5.5 21.25V18H4.75C2.67893 18 1 16.3211 1 14.25V5.75C1 3.67893 2.67893 2 4.75 2ZM8.75 10C8.75 10.6904 8.19036 11.25 7.5 11.25C6.80964 11.25 6.25 10.6904 6.25 10C6.25 9.30964 6.80964 8.75 7.5 8.75C8.19036 8.75 8.75 9.30964 8.75 10ZM13.25 10C13.25 10.6904 12.6904 11.25 12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10ZM17.75 10C17.75 10.6904 17.1904 11.25 16.5 11.25C15.8096 11.25 15.25 10.6904 15.25 10C15.25 9.30964 15.8096 8.75 16.5 8.75C17.1904 8.75 17.75 9.30964 17.75 10Z",
    stroke: "none",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBold);
export default __webpack_public_path__ + "static/media/chat-bold.ef5f218be14c6113d125df975e7e077f.svg";
export { ForwardRef as ReactComponent };